import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

// custom validator to check that two fields match
export function AlmostOneRequired(
  firstControlName: string,
  secondControlName: string
): ValidatorFn {
  return (formGroup: FormGroup): ValidationErrors | null => {
    const firstControl = formGroup.controls[firstControlName];
    const secondControl = formGroup.controls[secondControlName];

    if (!firstControl.value && !secondControl.value) {
      return { almostOneRequired: true };
    }

    return null;
  };
}
